<template>
  <div>
    <dt>{{ label }}</dt>
    <dd v-html="options[value]" />
  </div>
</template>

<script>
export default {
  name: "view-c-protocolo-declaracao-percentual-cursado",
  props: {
    label: String,
    value: String
  },
  data() {
    return {
      options: {
        "1": "Sim",
        "0": "Não"
      }
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/DeclaracaoPercentualCursado.vue